module.exports = __webpack_public_path__ + "img/docks_img.12fdfb02.svg";